export const set_services_phone_number = (phone_number) => {
  return {
    type: "SET_PHONE_NUMBER",
    phone_number,
  };
};

export const set_is_coupon = (is_coupon) => {
  return {
    type: "SET_is_coupon",
    is_coupon,
  };
};

export const set_services_odometer_value = (odometer_value) => {
  return {
    type: "SET_ODOMETER_VALUE",
    odometer_value,
  };
};



export const set_services_order_lines = (order_lines = []) => {
  return {
    type: "SET_ORDER_LINES",
    order_lines,
  };
};

export const set_services_user_car = (user_car_id, user_car_name, user_car_year, user_car_brand_name) => {
  return {
    type: "SET_USER_CAR",
    user_car_id,
    user_car_name,
    user_car_year,
    user_car_brand_name
  };
};

export const set_services_skip_step = (skip_step) => ({
  type: "SET_SKIP_STEP",
  skip_step,
});

export const set_services_qr_order_lines = (qr_order_lines) => ({
  type: "SET_QR_ORDER_LINES",
  qr_order_lines,
});

export const set_services_qr_meta = (qrMeta) => ({
  type: "SET_QR_META",
  qrMeta,
});

export const reset_qr_service_state = () => ({
  type: "RESET_QR_SERVICE_STATE",
});

export const reset_service_state = () => ({
  type: "RESET_SERVICE_STATE",
});